import COLORS from '../../../../utils/constants/colors'

const bracketStyles = {
  // Horizontal scroll container so wide brackets never push the page sideways.
  scroller: {
    width: '100%',
    overflowX: 'auto',
    padding: '16px 4px 24px',
  },
  // 'pairs' layout: one card per matchup, stacked vertically (full width up to a cap) so
  // long team names fit next to the per-game score cells.
  grid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    maxWidth: 640,
    padding: '16px 4px 24px',
  },
  // One column per round, laid out left-to-right (earliest round first).
  board: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '24px',
    minWidth: 'min-content',
  },
  round: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 260,
  },
  roundHeader: {
    fontSize: 13,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    color: COLORS.darkGrey,
    padding: '0 4px 12px',
    whiteSpace: 'nowrap',
  },
  seriesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  seriesCard: {
    border: `1px solid ${COLORS.borderGrey}`,
    borderRadius: 8,
    background: COLORS.white,
    overflow: 'hidden',
  },
  teamRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '8px 10px',
    '&:first-child': {
      borderBottom: `1px solid ${COLORS.borderGrey}`,
    },
  },
  teamLogo: {
    '&&': {
      width: 24,
      height: 24,
      fontSize: 12,
    },
  },
  teamName: {
    flex: 1,
    minWidth: 0,
    fontSize: 14,
    fontWeight: 600,
    color: COLORS.lightBlack,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  scoreCells: {
    display: 'flex',
    flexShrink: 0,
  },
  // Each score cell is its own button: clicking it opens that game's action menu.
  // The per-game winning score (`.is-win`) is bold and dark; the rest are muted.
  scoreCell: {
    width: 40,
    minWidth: 40,
    textAlign: 'center',
    border: 'none',
    borderLeft: `1px solid ${COLORS.borderGrey}`,
    background: 'transparent',
    font: 'inherit',
    fontSize: 14,
    fontWeight: 500,
    color: COLORS.grey,
    cursor: 'pointer',
    padding: '2px 0',
    transition: 'background-color 0.15s ease',
    '&.is-win': {
      fontWeight: 700,
      color: COLORS.black,
    },
    '&:hover:not(:disabled)': {
      backgroundColor: COLORS.backgroundGrey,
    },
    '&:disabled': {
      cursor: 'default',
    },
  },
  empty: {
    padding: '40px',
    textAlign: 'center',
  },
}

export default bracketStyles
